import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [state, setState] = useState<'pending' | 'done' | 'error'>('pending');
  const token = params.get('token');

  useEffect(() => {
    if (!token) {
      setState('error');
      return;
    }
    api(`/v1/auth/verify-email?token=${encodeURIComponent(token)}`, { method: 'POST', auth: false })
      .then(() => setState('done'))
      .catch(() => setState('error'));
  }, [token]);

  return (
    <main style={{ maxWidth: 360, margin: '4rem auto', fontFamily: 'system-ui, sans-serif' }}>
      <h1>Email verification</h1>
      {state === 'pending' && <p>Verifying…</p>}
      {state === 'done' && <p>Email verified. You can close this tab.</p>}
      {state === 'error' && <p>Verification link is invalid or expired.</p>}
    </main>
  );
}
